import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ElementRef,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MatSliderModule } from "@angular/material/slider";
import { MatExpansionModule, MatAccordion } from "@angular/material/expansion";

import { RecordData } from "src/app/types";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { GOST_I18N } from "./gost.i18n";

export interface FOISLevelRecommendation {
  fois: FOISLevel;
  stars: number;
  sortingValue: number;
}

export interface FOISLevel {
  stringValue: string;
  foodType: string;
  other: string;
}

const FOIS1: FOISLevel = {
  stringValue: "FOIS1",
  foodType: GOST_I18N.fois.fois1.foodType,
  other: GOST_I18N.fois.fois1.other,
};

const FOIS2: FOISLevel = {
  stringValue: "FOIS2",
  foodType: GOST_I18N.fois.fois2.foodType,
  other: GOST_I18N.fois.fois2.other,
};

const FOIS3: FOISLevel = {
  stringValue: "FOIS3",
  foodType: GOST_I18N.fois.fois3.foodType,
  other: GOST_I18N.fois.fois3.other,
};

const FOIS4: FOISLevel = {
  stringValue: "FOIS4",
  foodType: GOST_I18N.fois.fois4.foodType,
  other: GOST_I18N.fois.fois4.other,
};

const FOIS5_M: FOISLevel = {
  stringValue: "FOIS5-",
  foodType: GOST_I18N.fois.fois5m.foodType,
  other: GOST_I18N.fois.fois5m.other,
};

const FOIS5_P: FOISLevel = {
  stringValue: "FOIS5+",
  foodType: GOST_I18N.fois.fois5p.foodType,
  other: GOST_I18N.fois.fois5p.other,
};

const FOIS6: FOISLevel = {
  stringValue: "FOIS6",
  foodType: GOST_I18N.fois.fois6.foodType,
  other: GOST_I18N.fois.fois6.other,
};

const FOIS7: FOISLevel = {
  stringValue: "FOIS7",
  foodType: GOST_I18N.fois.fois7.foodType,
  other: GOST_I18N.fois.fois7.other,
};

const GOST_1: FOISLevelRecommendation[] = [
  { fois: FOIS1, stars: 5, sortingValue: 7 },
  { fois: FOIS2, stars: 2, sortingValue: 6 },
  { fois: FOIS3, stars: 1, sortingValue: 5 },
  { fois: FOIS4, stars: 1, sortingValue: 4 },
  { fois: FOIS5_M, stars: 1, sortingValue: 3 },
  { fois: FOIS5_P, stars: 1, sortingValue: 2 },
  { fois: FOIS6, stars: 1, sortingValue: 1 },
  { fois: FOIS7, stars: 1, sortingValue: 0 },
];

const GOST_2: FOISLevelRecommendation[] = [
  { fois: FOIS1, stars: 4, sortingValue: 6 },
  { fois: FOIS2, stars: 5, sortingValue: 7 },
  { fois: FOIS3, stars: 2, sortingValue: 5 },
  { fois: FOIS4, stars: 1, sortingValue: 4 },
  { fois: FOIS5_M, stars: 1, sortingValue: 3 },
  { fois: FOIS5_P, stars: 1, sortingValue: 2 },
  { fois: FOIS6, stars: 1, sortingValue: 1 },
  { fois: FOIS7, stars: 1, sortingValue: 0 },
];

const GOST_3: FOISLevelRecommendation[] = [
  { fois: FOIS1, stars: 3, sortingValue: 5 },
  { fois: FOIS2, stars: 4, sortingValue: 6 },
  { fois: FOIS3, stars: 5, sortingValue: 7 },
  { fois: FOIS4, stars: 2, sortingValue: 4 },
  { fois: FOIS5_M, stars: 1, sortingValue: 3 },
  { fois: FOIS5_P, stars: 1, sortingValue: 2 },
  { fois: FOIS6, stars: 1, sortingValue: 1 },
  { fois: FOIS7, stars: 1, sortingValue: 0 },
];

const GOST_4: FOISLevelRecommendation[] = [
  { fois: FOIS1, stars: 1, sortingValue: 1 },
  { fois: FOIS2, stars: 1, sortingValue: 2 },
  { fois: FOIS3, stars: 2, sortingValue: 4 },
  { fois: FOIS4, stars: 5, sortingValue: 7 },
  { fois: FOIS5_M, stars: 4, sortingValue: 6 },
  { fois: FOIS5_P, stars: 3, sortingValue: 5 },
  { fois: FOIS6, stars: 2, sortingValue: 3 },
  { fois: FOIS7, stars: 1, sortingValue: 0 },
];

const GOST_5: FOISLevelRecommendation[] = [
  { fois: FOIS1, stars: 1, sortingValue: 0 },
  { fois: FOIS2, stars: 1, sortingValue: 1 },
  { fois: FOIS3, stars: 1, sortingValue: 2 },
  { fois: FOIS4, stars: 2, sortingValue: 4 },
  { fois: FOIS5_M, stars: 5, sortingValue: 7 },
  { fois: FOIS5_P, stars: 4, sortingValue: 6 },
  { fois: FOIS6, stars: 3, sortingValue: 5 },
  { fois: FOIS7, stars: 2, sortingValue: 3 },
];

const GOST_6: FOISLevelRecommendation[] = [
  { fois: FOIS1, stars: 1, sortingValue: 0 },
  { fois: FOIS2, stars: 1, sortingValue: 1 },
  { fois: FOIS3, stars: 1, sortingValue: 2 },
  { fois: FOIS4, stars: 2, sortingValue: 3 },
  { fois: FOIS5_M, stars: 3, sortingValue: 5 },
  { fois: FOIS5_P, stars: 5, sortingValue: 7 },
  { fois: FOIS6, stars: 4, sortingValue: 6 },
  { fois: FOIS7, stars: 2, sortingValue: 4 },
];

const GOST_7: FOISLevelRecommendation[] = [
  { fois: FOIS1, stars: 1, sortingValue: 0 },
  { fois: FOIS2, stars: 1, sortingValue: 1 },
  { fois: FOIS3, stars: 1, sortingValue: 2 },
  { fois: FOIS4, stars: 1, sortingValue: 3 },
  { fois: FOIS5_M, stars: 2, sortingValue: 4 },
  { fois: FOIS5_P, stars: 3, sortingValue: 5 },
  { fois: FOIS6, stars: 5, sortingValue: 7 },
  { fois: FOIS7, stars: 4, sortingValue: 6 },
];

const GOST_8: FOISLevelRecommendation[] = [
  { fois: FOIS1, stars: 1, sortingValue: 0 },
  { fois: FOIS2, stars: 1, sortingValue: 1 },
  { fois: FOIS3, stars: 1, sortingValue: 2 },
  { fois: FOIS4, stars: 1, sortingValue: 3 },
  { fois: FOIS5_M, stars: 1, sortingValue: 4 },
  { fois: FOIS5_P, stars: 2, sortingValue: 5 },
  { fois: FOIS6, stars: 3, sortingValue: 6 },
  { fois: FOIS7, stars: 5, sortingValue: 7 },
];

const gostLevels: FOISLevelRecommendation[][] = [
  GOST_1,
  GOST_2,
  GOST_3,
  GOST_4,
  GOST_5,
  GOST_6,
  GOST_7,
  GOST_8,
];

@Component({
  imports: [...SHARED_IMPORTS, MatSliderModule, MatExpansionModule],

  selector: "gost-recording-card",
  templateUrl: "./gost-recording.component.html",
  styleUrls: ["./recording.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GostRecordingComponent implements OnInit, AfterViewInit {
  @ViewChild("bodyAngleCanvas", { static: false }) bodyAngleCanvas: ElementRef;

  @ViewChild("circle1", { static: false }) circleStep1: ElementRef;
  @ViewChild("circle2", { static: false }) circleStep2: ElementRef;
  @ViewChild("circle3", { static: false }) circleStep3: ElementRef;
  @ViewChild("circle4", { static: false }) circleStep4: ElementRef;

  circlesStep: ElementRef[] = [];

  @ViewChild("dash1", { static: false }) dash1: ElementRef;
  @ViewChild("dash2", { static: false }) dash2: ElementRef;
  @ViewChild("dash3", { static: false }) dash3: ElementRef;

  dashes: ElementRef[] = [];

  @ViewChild("gostR1") gostR1: ElementRef<HTMLInputElement>;
  @ViewChild("gostR2") gostR2: ElementRef<HTMLInputElement>;
  @ViewChild("gostR3") gostR3: ElementRef<HTMLInputElement>;
  @ViewChild("gostR4") gostR4: ElementRef<HTMLInputElement>;
  @ViewChild("gostR5") gostR5: ElementRef<HTMLInputElement>;
  @ViewChild("gostR6") gostR6: ElementRef<HTMLInputElement>;
  @ViewChild("gostR7") gostR7: ElementRef<HTMLInputElement>;
  @ViewChild("gostR8") gostR8: ElementRef<HTMLInputElement>;

  @ViewChild(MatAccordion) accordion: MatAccordion;

  @Input() recordData: RecordData;

  public context: CanvasRenderingContext2D;

  currentGost: FOISLevelRecommendation[];

  consciousnessValue: string;

  newsScore: number = -1;

  newsRisk: String = "NONE";

  modifiedRankingScale: string = "";
  articulationLevel: number = -1;
  leftHandScore: string = "";
  rightHandScore: string = "";

  rows = [
    {
      category: GOST_I18N.gcRows.awakening.category,
      values: GOST_I18N.gcRows.awakening.values as unknown as string[],
    },
    {
      category: GOST_I18N.gcRows.temperature.category,
      values: GOST_I18N.gcRows.temperature.values as unknown as string[],
    },
    {
      category: GOST_I18N.gcRows.pulse.category,
      values: GOST_I18N.gcRows.pulse.values as unknown as string[],
    },
    {
      category: GOST_I18N.gcRows.spo2.category,
      values: GOST_I18N.gcRows.spo2.values as unknown as string[],
    },
    {
      category: GOST_I18N.gcRows.breath.category,
      values: GOST_I18N.gcRows.breath.values as unknown as string[],
    },
    {
      category: GOST_I18N.gcRows.oxygen.category,
      values: GOST_I18N.gcRows.oxygen.values as unknown as string[],
    },
    {
      category: GOST_I18N.gcRows.sputum.category,
      values: GOST_I18N.gcRows.sputum.values as unknown as string[],
    },
  ];

  selectedValues = {};

  onSelect(rowCategory: string, value: string) {
    this.selectedValues[rowCategory] = value;
  }

  ngOnInit() {
    if (!this.recordData) return;

    this.currentGost = gostLevels[this.recordData.data.mGostScore - 1];

    // this.currentGost.sort((firstItem, secondItem) => secondItem.sortingValue - firstItem.sortingValue);

    this.newsScore = 0;

    let redNumber = 0;

    switch (this.recordData.data.newsScore.consciousnessLevel) {
      case "A":
        this.consciousnessValue = "Aware";
        this.newsScore += 0;
        break;

      default:
        this.newsScore += 3;
        redNumber += 1;
        break;
    }

    if (this.recordData.data.newsScore.onOxygen) {
      this.newsScore += 2;
    }

    if (this.newsScore <= 4) {
      if (redNumber >= 1) {
        this.newsRisk = "A single red score";
      } else {
        this.newsRisk = "LOW";
      }
    } else if (this.newsScore <= 6) {
      this.newsRisk = "MEDIUM";
    } else {
      this.newsRisk = "HIGH";
    }

    var leftHandScore = this.recordData.data.questionnaire2Answers.find(
      ({ questionCode }) => questionCode === "G_Q_LEFT_ARM",
    ).score;

    switch (leftHandScore) {
      case 0:
        this.leftHandScore = "5";
        break;

      case 1:
        this.leftHandScore = "4";
        break;

      case 2:
        this.leftHandScore = "2-3";
        break;

      case 3:
        this.leftHandScore = "0-1";
        break;
    }

    var rightHandScore = this.recordData.data.questionnaire2Answers.find(
      ({ questionCode }) => questionCode === "G_Q_RIGHT_ARM",
    ).score;

    switch (rightHandScore) {
      case 0:
        this.rightHandScore = "5";
        break;

      case 1:
        this.rightHandScore = "4";
        break;

      case 2:
        this.rightHandScore = "2-3";
        break;

      case 3:
        this.rightHandScore = "0-1";
        break;
    }

    this.articulationLevel = this.recordData.data.questionnaire2Answers.find(
      ({ questionCode }) => questionCode === "G_Q_ARTICULATION_LEVEL",
    ).score;

    var disabilityScoreRanking = -1;

    // var disabilityLevel = this.recordData.data.questionnaire2Answers.find(({ questionCode }) => questionCode === 'G_Q_DISABILITY_LEVEL').score;
    var disabilityLevel = 1;
    switch (disabilityLevel) {
      case 0:
        disabilityScoreRanking = 1;
        break;

      case 1:
        disabilityScoreRanking = 2.5;
        break;

      case 2:
        disabilityScoreRanking = 4;
        break;

      case 3:
        disabilityScoreRanking = 5;
        break;
    }

    var cognitiveScoreRanking = -1;

    var cognitiveLevel = this.recordData.data.questionnaire2Answers.find(
      ({ questionCode }) => questionCode === "G_Q_COGNITIVE_LEVEL",
    ).score;
    switch (cognitiveLevel) {
      case 0:
        cognitiveScoreRanking = 1;
        break;

      case 1:
        cognitiveScoreRanking = 2.5;
        break;

      case 2:
        cognitiveScoreRanking = 4;
        break;

      case 3:
        cognitiveScoreRanking = 5;
        break;
    }

    if (disabilityScoreRanking == cognitiveScoreRanking) {
      if (disabilityScoreRanking == 2.5) {
        this.modifiedRankingScale = "2 - 3";
      } else {
        this.modifiedRankingScale = disabilityScoreRanking.toString();
      }
    } else {
      if (disabilityScoreRanking < cognitiveScoreRanking) {
        var min = disabilityScoreRanking == 2.5 ? 2 : disabilityScoreRanking;
        var max = cognitiveScoreRanking == 2.5 ? 3 : cognitiveScoreRanking;

        this.modifiedRankingScale = min.toString() + " - " + max.toString();
      } else {
        var min = cognitiveScoreRanking == 2.5 ? 2 : cognitiveScoreRanking;
        var max = disabilityScoreRanking == 2.5 ? 3 : disabilityScoreRanking;

        this.modifiedRankingScale = min.toString() + " - " + max.toString();
      }
    }

  }

  ngAfterViewInit() {
    this.circlesStep = [
      this.circleStep1,
      this.circleStep2,
      this.circleStep3,
      this.circleStep4,
    ];

    this.dashes = [this.dash1, this.dash2, this.dash3];

    if (
      this.recordData.data.gostPath[0] == null &&
      this.recordData.data.gostPath[1] == null &&
      this.recordData.data.gostPath[2] == null &&
      this.recordData.data.gostPath[3] != null
    ) {
      //only 30mL challenge
      this.circleStep1.nativeElement.classList.remove("circle-none");
      this.circleStep1.nativeElement.classList.add("circle-grey");

      this.circleStep2.nativeElement.classList.remove("circle-none");
      this.circleStep2.nativeElement.classList.add("circle-grey");

      this.circleStep2.nativeElement.classList.remove("circle-none");
      this.circleStep2.nativeElement.classList.add("circle-grey");

      this.circleStep3.nativeElement.classList.remove("circle-none");
      this.circleStep3.nativeElement.classList.add("circle-grey");

      this.circleStep4.nativeElement.classList.remove("circle-none");

      switch (this.recordData.data.gostPath[3]) {
        case "C":
          this.circleStep4.nativeElement.classList.add("circle-complete");
          break;

        case "I":
          this.circleStep4.nativeElement.classList.add("circle-inconsistent");
          break;

        case "F":
          this.circleStep4.nativeElement.classList.add("circle-fail");
          break;
      }
    } else {
      for (let i = 0; i < this.recordData.data.gostPath.length; i++) {
        this.circlesStep[i].nativeElement.classList.remove("circle-none");

        switch (this.recordData.data.gostPath[i]) {
          case "C":
            this.circlesStep[i].nativeElement.classList.add("circle-complete");
            break;

          case "CT":
            this.circlesStep[i].nativeElement.innerHTML = "T";
            this.circlesStep[i].nativeElement.classList.add("circle-complete");
            break;

          case "I":
            this.circlesStep[i].nativeElement.classList.add(
              "circle-inconsistent",
            );
            break;

          case "IT":
            this.circlesStep[i].nativeElement.innerHTML = "T";
            this.circlesStep[i].nativeElement.classList.add(
              "circle-inconsistent",
            );
            break;

          case "F":
            this.circlesStep[i].nativeElement.classList.add("circle-fail");
            break;

          case "FT":
            this.circlesStep[i].nativeElement.innerHTML = "T";
            this.circlesStep[i].nativeElement.classList.add("circle-fail");
            break;

          case null:
            this.circlesStep[i].nativeElement.classList.add("circle-none");
            break;
        }

        if (i > 0 && i < 4 && this.recordData.data.gostPath[i] != null) {
          this.dashes[i - 1].nativeElement.classList.add("dash");
        }
      }
    }

    this.context = this.bodyAngleCanvas.nativeElement.getContext("2d");

    this.setCanvasSize(this.context.canvas);

    this.drawBodyAngle();
  }

  setCanvasSize(canvas) {
    // var parent = canvas.parentNode,
    // 	styles = getComputedStyle(parent),
    // 	w = parseInt(styles.getPropertyValue("width"), 10),
    // 	h = parseInt(styles.getPropertyValue("height"), 10);

    canvas.width = 300;
    canvas.height = 150;
  }

  drawBodyAngle() {
    var canvasWidth = this.bodyAngleCanvas.nativeElement.offsetWidth;
    var canvasHeight = this.bodyAngleCanvas.nativeElement.offsetHeight;

    var widthThird = canvasWidth / 2.3;
    var heightThird = canvasHeight / 3.0 + 5;

    var chairWidth = 50;
    var chairLegsHeight = 35;
    var chairBackLength = 60;

    this.context.beginPath();
    this.context.moveTo(widthThird, heightThird * 2);
    this.context.lineTo(widthThird + chairWidth, heightThird * 2);
    this.context.lineWidth = 3;
    this.context.strokeStyle = "black";
    this.context.stroke();

    this.context.beginPath();
    this.context.moveTo(widthThird, heightThird * 2);
    this.context.lineTo(widthThird, heightThird * 2 + chairLegsHeight);
    this.context.lineWidth = 3;
    this.context.strokeStyle = "black";
    this.context.stroke();

    this.context.beginPath();
    this.context.moveTo(widthThird + chairWidth, heightThird * 2);
    this.context.lineTo(
      widthThird + chairWidth,
      heightThird * 2 + chairLegsHeight,
    );
    this.context.lineWidth = 3;
    this.context.strokeStyle = "black";
    this.context.stroke();

    // var angle = 50;
    var angle = this.recordData.data.newsScore.bodyAngle;
    var angleRad = (Math.PI * (-90 - angle)) / 180.0;

    this.context.beginPath();
    this.context.moveTo(widthThird, heightThird * 2);
    // this.context.lineTo(canvasWidth * 2/3, canvasHeight*2/3);
    var backEndX = widthThird + chairBackLength * Math.cos(angleRad);
    var backEndY = heightThird * 2 + chairBackLength * Math.sin(angleRad);

    this.context.lineTo(backEndX, backEndY);
    this.context.lineWidth = 3;
    this.context.strokeStyle = "red";
    this.context.stroke();

    // Draw the ellipse
    this.context.beginPath();
    this.context.translate(chairWidth / 2, -5);
    this.context.ellipse(
      (widthThird + backEndX) / 2,
      (heightThird * 2 + backEndY) / 2,
      chairBackLength / 2,
      20,
      angleRad,
      0,
      2 * Math.PI,
    );
    this.context.strokeStyle = "black";
    this.context.stroke();

    // this.context.setTransform(1, 0, 0, 1, 0, 0);

    this.context.beginPath();
    this.context.arc(backEndX, backEndY - 20, 15, 0, 2 * Math.PI);
    this.context.stroke();

    this.context.setTransform(1, 0, 0, 1, 0, 0);

    // this.context.beginPath();
    // this.context.ellipse(widthThird + chairWidth, heightThird * 2 - 10, chairBackLength / 2, 12, Math.PI * 20 / 180.0, 0, 2 * Math.PI);
    // this.context.strokeStyle = 'black';
    // this.context.fillStyle = 'white';
    // this.context.stroke();
    // // this.context.fill();

    // this.context.beginPath();
    // this.context.ellipse(widthThird + chairWidth + 18, heightThird * 2 + 10, chairBackLength / 3 + 5, 10, Math.PI * 80 / 180.0, 0, 2 * Math.PI);
    // this.context.strokeStyle = 'black';
    // this.context.fillStyle = 'white';
    // this.context.stroke();
    // // this.context.fill();

    // this.context.beginPath();
    // this.context.moveTo(widthThird + chairWidth / 2, heightThird * 2 - 20);
    // this.context.lineTo(widthThird + chairWidth / 2 + chairWidth / 2 + 10, heightThird * 2 - 20);
    // this.context.lineTo(widthThird + chairWidth / 2 + chairWidth / 2 + 20, heightThird * 2 + chairLegsHeight - 20);
    // this.context.stroke();
  }

  oneStarRatingHTML = `
	   <div style="display: flex; flex-direction: column; align-content: stretch;">
	      <span style="text-align: center;">1</span>
	      <div style="display: flex; justify-content: space-evenly;">
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
	      </div>
	   </div>
	`;

  twoStarRatingHTML = `
	   <div style="display: flex; flex-direction: column; align-content: stretch;">
	      <span style="text-align: center;">1</span>
	      <div style="display: flex; justify-content: space-evenly;">
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
	      </div>
	   </div>
	`;

  threeStarRatingHTML = `
	   <div style="display: flex; flex-direction: column; align-content: stretch;">
	      <span style="text-align: center;">1</span>
	      <div style="display: flex; justify-content: space-evenly;">
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
	      </div>
	   </div>
	`;

  fourStarRatingHTML = `
	   <div style="display: flex; flex-direction: column; align-content: stretch;">
	      <span style="text-align: center;">1</span>
	      <div style="display: flex; justify-content: space-evenly;">
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star">star_outline</mat-icon>
	      </div>
	   </div>
	`;

  fiveStarRatingHTML = `
	   <div style="display: flex; flex-direction: column; align-content: stretch;">
	      <span style="text-align: center;">1</span>
	      <div style="display: flex; justify-content: space-evenly;">
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
		    <mat-icon aria-hidden="false" aria-label="star" class="star">star</mat-icon>
	      </div>
	   </div>
	`;
}
